import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";

import configureStoreProd from "./config/configureStore.prod";
import { Provider, useDispatch, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import { lazy, Suspense, useEffect, useState } from 'react';
import { memo } from 'react';

import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "./App.css";
import "./scss/main.scss";
import Layout from "./components/global/AuthLayout";
import permissionModel from "./models/permisstion.model";
import socketModel from "./models/socketModel";
import { logout } from "./actions/user";
import ErrorBoundary from "./components/ErrorBoundary"
import SEODashboard from "./Pages/SEODashboard/SeoDashboard";
import LivePageSettings from "./Pages/GoLiveSettings/GoLiveSettings";
import methodModel from "./methods/methods";
import FulfillmentRouteState from "./Pages/Fulfillment/FulfillmentRouteState";


const { persistor, store } = configureStoreProd();

const Loading = ({ id = '', className = '' }) => {
  return <>
    <div id={id} className={`loaderDiv ${className}`}>
      <div>
        <img
          src="/assets/img/loader.gif"
          alt="logo"
          className="loaderlogo"
        />
      </div>
    </div>
  </>
}

const PageRoute = ({ children, auth, url, Layout = '' }: any) => {
  const user = useSelector((state: any) => state.user);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const history = useNavigate();
  const dispatch = useDispatch()
  let noAccess = !permissionModel.urlAllow(user)
  if (!user.loggedIn && auth) noAccess = true

  useEffect(() => {
    if (user.loggedIn) {
      if (noAccess) history('/profile?noAccess=true')
    } else {
      if (auth) history('/login')
    }
  }, [url, user])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [url])
  useEffect(() => {
    if (methodModel.getPrams("noAccess") === "true") {
      methodModel.showError("You have no access for this page");
      const url = new URL(window.location.href);
      url.searchParams.delete("noAccess");
      window.history.replaceState({}, "", url.pathname + url.search);
    }
  }, [])

  useEffect(() => {
    if (user.loggedIn || isLoggedIn) {
      let minutes = 0
      if (user?.idlTime != 'Never' && user?.idlTime) {
        let time = Number(user?.idlTime.split(' ')[0]) || 0
        minutes = time * 1000
      }

      const IDLE_TIMEOUT = minutes
      let timeout: any;

      const resetTimer = () => {
        clearTimeout(timeout);
        timeout = setTimeout(Logout, IDLE_TIMEOUT);
      };

      const Logout = () => {
        if (isLoggedIn && minutes && user?.role?.name === "Staff") {
          socketModel.emit("user-offline", { user_id: user?._id || user?.id });
          dispatch(logout());
          localStorage.removeItem("token");
          setIsLoggedIn(false);
        }
      };

      window.addEventListener("mousemove", resetTimer);
      window.addEventListener("keypress", resetTimer);
      window.addEventListener("scroll", resetTimer);
      window.addEventListener("click", resetTimer);
      resetTimer();

      return () => {
        clearTimeout(timeout);
        window.removeEventListener("mousemove", resetTimer);
        window.removeEventListener("keypress", resetTimer);
        window.removeEventListener("scroll", resetTimer);
        window.removeEventListener("click", resetTimer);
      };
    }
  }, [user.loggedIn]);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        let ip = data.ip;
        localStorage.setItem("IP", ip);
      })
      .catch((error) => console.error("Error fetching IP address:", error));

    // ApiClient.get('subscription/saveSubscriptionGrooveGuide').then(res=>{

    // })
  }, [])

  if (noAccess) return <></>

  return <>
    <ErrorBoundary>
      {isLoggedIn ? <>
        {Layout ? <>
          <Layout>
            {children}
          </Layout>
        </> : <>
          {children}
        </>}
      </> : <>
        <div className="p-4 text-center">
          <div>You have been logged out due to inactivity.</div>
          <div className="text-center mt-2">
            <button
              type="button"
              onClick={() => {
                setIsLoggedIn(true);
                history('/login')
              }}
              className="text-white bg-[#540C0F] bg-[#540C0F] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              Login
            </button>
          </div>
        </div>
      </>}
    </ErrorBoundary>
  </>
}


const App = memo(function App() {
  const routes = [
    { url: "/login", path: 'Login', noAuth: true },
    { url: "/stafflogin", path: 'StaffLogin' },
    { url: "/exportmatch", path: 'ExportMatch' },
    { url: "/dashboard", path: 'Dashboard' },
    { url: "/experience", path: 'Dashboard/Experience' },
    { url: "/dashboard1", path: 'Dashboard/Overview' },
    { url: "/backendExperiences", path: 'Dashboard/BackendExperiences' },
    // { url: "/", path: 'Dashboard/Overview' },
    { url: "/", path: 'Dashboard' },
    { url: "/paymentStatus", path: 'Dashboard/PaymentStatusNew' },
    { url: "/paymentStatusNew", path: 'Dashboard/PaymentStatusNew' },

    { url: "/checkin-report", path: 'Dashboard/CheckinDashbaord' },
    { url: "/checkin-reports", path: 'Dashboard/CheckinDashboardNew' },

    { url: "/checkin-report/list", path: 'Dashboard/CheckinReportList' },

    { url: "/dashboard/marketing-analytics", path: 'Dashboard/MarketingAnalytics' },
    { url: "/marketing/insights", path: 'Dashboard/MarketingAnalytics' },
    // { url: "/sales/regional", path: 'Sales/RegionalSales' },
    { url: "/sales/regional", path: 'Sales/RegionalSales2' },

    { url: "/sales/regional-report", path: 'Sales/RegionalReport' },
    { url: "/sales/insights", path: 'Sales/Insights' },
    // { url: "/sales/insights", path: 'Sales/SalesOverview' },
    // { url: "/sales/history", path: 'Sales/ItemsSales' },
    { url: "/sales/history", path: 'Sales/ProductHistory' },
    { url: "/membership/insights1", path: 'Dashboard/MembershipSales' },
    { url: "/membership/insights", path: 'Dashboard/MembershipAnalytics' },
    { url: "/membership/boxsale", path: 'Dashboard/MembershipAnalyticsBoxSale' },

    { url: "/membership/history", path: 'Membership/History' },

    { url: "/dashboard/share-experience-history", path: 'Dashboard/ShareExperienceHistory' },
    { url: "/share-experience", path: 'Dashboard/ShareExperienceHistory' },
    // { url: "/share-experience", path: 'ShareExp' },
    { url: "/share-experience/detail/:id", path: 'ShareExp/View' },
    { url: "/engagement/behavioral", path: 'EngagementContent/Behavioral' },
    { url: "/dashboard/share-experience-overview", path: 'Dashboard/SharedExpOverview' },
    { url: "/share-experience/overview", path: 'Dashboard/SharedExpOverview' },
    { url: "/dashboard/share-experience-by-product", path: 'Dashboard/ShareExperienceByProduct' },
    { url: "/share-experience/insights", path: 'Dashboard/ShareExperienceByProduct' },
    { url: "/dashboard/share-experience-by-experiences", path: 'Dashboard/ShareExperienceByExperiences' },
    { url: "/dashboard/survey-data", path: 'Dashboard/SurveyAnalytics' },
    { url: "/survey/insights", path: 'Dashboard/SurveyAnalytics' },
    { url: "/checkin", path: 'Dashboard/Checkin' },
    { url: "/checkin-settings", path: 'LoyalMember/CheckinSettings' },
    { url: "*", path: 'NotFoundPage' },
    { url: "/profile", path: 'Profile' },
    { url: "/contentSettings", path: 'contentSettings' },
    { url: "/kiosk-management", path: 'KioskManagement' },

    { url: "/welcomeSeries", path: 'Welcome-series' },
    { url: "/welcomeSeries/add", path: 'Welcome-series/AddEdit' },
    { url: "/welcomeSeries/edit/:id", path: 'Welcome-series/AddEdit' },
    // { url: "/welcome-series", path: 'Welcome-series' },

    { url: "/profile/:tab", path: 'Settings' },
    { url: "/forgotpassword", path: 'Forgotpassword', noAuth: true },
    { url: "/resetpassword", path: 'Resetpassword', noAuth: true },
    { url: "/verify-process", path: 'EVAResetPassword', noAuth: true },

    { url: "/roles", path: 'Roles' },
    { url: "/roles/add", path: 'Roles/AddEdit' },
    { url: "/roles/edit/:id", path: 'Roles/AddEdit' },
    { url: "/user", path: 'Users' },
    { url: "/user/edit/:id", path: 'Users/AddEdit' },
    { url: "/user/add", path: 'Users/AddEdit' },
    { url: "/user/detail/:id", path: 'Users/View' },
    { url: "/partner/request", path: 'Partnership' },
    { url: "/partner/request/detail/:id", path: 'Partnership/View' },
    { url: "/category", path: 'Categories' },
    { url: "/category/add", path: 'Categories/AddEdit' },
    { url: "/category/detail/:id", path: 'Categories/View' },
    { url: "/category/edit/:id", path: 'Categories/AddEdit' },
    { url: "/product-category", path: 'ProductCategories' },
    { url: "/product-category/add", path: 'ProductCategories/AddEdit' },
    { url: "/product-category/detail/:id", path: 'ProductCategories/View' },
    { url: "/product-category/edit/:id", path: 'ProductCategories/AddEdit' },

    { url: "/product", path: 'Products' },
    { url: "/product/add", path: 'Products/AddEdit' },
    { url: "/product/detail/:id", path: 'Products/View' },
    { url: "/product/edit/:id", path: 'Products/AddEdit' },
    { url: "/faq", path: 'FAQ' },
    { url: "/faq/add", path: 'FAQ/AddEdit' },
    { url: "/faq/detail/:id", path: 'FAQ/View' },
    { url: "/faq/edit/:id", path: 'FAQ/AddEdit' },
    { url: "/content", path: 'Content' },
    { url: "/content/detail/:slug", path: 'Content/View' },
    { url: '/monthly-box/add', path: 'MonthlyBox/MonthlyBoxChange' },
    { url: '/monthly-box/edit/:id', path: 'MonthlyBox/MonthlyBoxChange' },
    { url: '/monthly-box', path: 'MonthlyBox/ListMonthlyBox' },
    { url: "/Bundles/add", path: 'Bundles/add/page' },
    { url: "/Bundles/compose", path: 'Bundles/compose/page' },
    { url: "/Bundles/compose/:boxId", path: 'Bundles/compose/page' },
    { url: "/Bundles/walkthrough", path: 'Bundles/walkthrough/page' },
    { url: "/Bundles/confirm-batch", path: 'Bundles/confirm-batch/page' },
    { url: "/Bundles/confirm/:id", path: 'Bundles/confirm/page' },
    { url: "/content/add", path: 'Content/AddEdit' },
    { url: "/content/edit/:slug", path: 'Content/AddEdit' },
    { url: "/newsletter", path: 'Newsletter' },
    { url: "/newsletter/detail/:id", path: 'Newsletter/View' },
    { url: "/question", path: 'Questions' },
    { url: "/question/add", path: 'Questions/AddEdit' },
    { url: "/question/detail/:id", path: 'Questions/View' },
    { url: "/question/edit/:id", path: 'Questions/AddEdit' },
    { url: "/subscription", path: 'Subscriptions' },
    { url: "/subscription/detail/:id", path: 'Subscriptions/View' },
    { url: "/tag", path: 'Tags' },
    { url: "/tag/add", path: 'Tags/AddEdit' },
    { url: "/tag/detail/:id", path: 'Tags/View' },
    { url: "/tag/edit/:id", path: 'Tags/AddEdit' },
    { url: "/survey", path: 'Survey' },
    { url: "/survey/add", path: 'Survey/AddEdit' },
    { url: "/survey/detail/:id", path: 'Survey/View' },
    { url: "/survey/edit/:id", path: 'Survey/AddEdit' },
    { url: "/strain", path: 'Strain' },
    { url: "/automation", path: 'StaticGeneration' },
    { url: "/automation/add", path: 'StaticGeneration/AddEdit' },
    { url: "/rankchecker", path: 'StaticGeneration/RankChecker' },
    { url: "/rankchecker/add", path: 'StaticGeneration/RankChecker/AddEdit' },

    { url: "/keywordsresearch", path: 'StaticGeneration/KeywordsCheck/index.js' },
    { url: "/keywordsresearch/add", path: 'StaticGeneration/KeywordsCheck/AddEdit' },

    { url: "/events", path: 'Events' },
    { url: "/events/add", path: 'Events/AddEdit' },
    { url: "/events/edit/:id", path: 'Events/AddEdit' },
    { url: "/strain/add", path: 'Strain/AddEdit' },
    { url: "/strain/detail/:id", path: 'Strain/View' },
    { url: "/strain/edit/:id", path: 'Strain/AddEdit' },
    { url: "/deal", path: 'Deal' },
    { url: "/deal/add", path: 'Deal/AddEdit' },
    { url: "/deal/detail/:id", path: 'Deal/View' },
    { url: "/deal/edit/:id", path: 'Deal/AddEdit' },
    { url: "/flavor", path: 'Flavor' },
    { url: "/flavor/add", path: 'Flavor/AddEdit' },
    { url: "/flavor/detail/:id", path: 'Flavor/View' },
    { url: "/flavor/edit/:id", path: 'Flavor/AddEdit' },
    { url: "/ingredient", path: 'Ingredient' },
    { url: "/ingredient/add", path: 'Ingredient/AddEdit' },
    { url: "/ingredient/detail/:id", path: 'Ingredient/View' },
    { url: "/ingredient/edit/:id", path: 'Ingredient/AddEdit' },
    { url: "/banner", path: 'Banners' },
    { url: "/banner/add", path: 'Banners/AddEdit' },
    { url: "/banner/detail/:id", path: 'Banners/View' },
    { url: "/banner/edit/:id", path: 'Banners/AddEdit' },
    { url: "/plans", path: 'Plans' },
    { url: "/plans/add", path: 'Plans/AddEdit' },
    { url: "/plans/detail/:id", path: 'Plans/View' },
    { url: "/plans/edit/:id", path: 'Plans/AddEdit' },
    { url: "/blog", path: 'Blogs' },
    { url: "/blog/add", path: 'Blogs/AddEdit' },
    { url: "/blog/detail/:id", path: 'Blogs/View' },
    { url: "/blog/edit/:id", path: 'Blogs/AddEdit' },
    { url: "/resources", path: 'Resources' },
    { url: "/resources/add", path: 'Resources/AddEdit' },
    { url: "/resources/detail/:id", path: 'Resources/View' },
    { url: "/resources/edit/:id", path: 'Resources/AddEdit' },
    { url: "/subscribers", path: 'Emails' },
    { url: "/subscribers/send-newsletter", path: 'Emails/Send' },
    // { url: "/customers/:type", path: 'GrooveGroup' },
    // { url: "/customers/:type/:membership", path: 'GrooveGroup' },
    // { url: "/customers", path: 'GrooveGroup' },
    // { url: "/customers/edit/:id", path: 'GrooveGroup/AddEdit' },
    // { url: "/customers/add", path: 'GrooveGroup/AddEdit' },
    // { url: "/customers/detail/:id", path: 'GrooveGroup/View' },
    { url: "/member/add", path: 'GrooveGroup/AddEdit' },
    { url: "/member/edit/:id", path: 'GrooveGroup/CompleteEdit' },
    // { url: "/member/edit/:id", path: 'GrooveGroup/AddEdit' },
    { url: "/videos/:type", path: 'Videos' },
    { url: "/groove/videos", path: 'GrooveGuideVideos' },
    { url: "/groove/videos/add", path: 'GrooveGuideVideos/AddEdit' },
    { url: "/groove/videos/edit/:id", path: 'GrooveGuideVideos/AddEdit' },
    { url: "/groove/videos/detail/:id", path: 'GrooveGuideVideos/View' },



    { url: "/videos/:type/add", path: 'Videos/AddEdit' },
    { url: "/videos/edit/:id", path: 'Videos/AddEdit' },
    { url: "/videos/detail/:id", path: 'Videos/View' },
    { url: "/audio", path: 'Audio' },
    { url: "/audio/add", path: 'Audio/AddEdit' },
    { url: "/audio/:id", path: 'Audio/AddEdit' },
    { url: "/audio/:id", path: 'Audio/View' },

    { url: "/audio/:type", path: 'Audio' },
    { url: "/audio/:type/add", path: 'Audio/AddEdit' },
    { url: "/audio/edit/:id", path: 'Audio/AddEdit' },
    { url: "/audio/detail/:id", path: 'Audio/View' },
    { url: "/notifications", path: 'Messages' },
    { url: "/notifications/detail/:id", path: 'Messages/View' },
    { url: "/notifications/send-notification", path: 'Messages/Send' },
    { url: "/chat", path: 'Chats' },
    { url: "/orders", path: 'Orders' },
    { url: "/order-fulfillment", path: 'Fulfillment' },
    { url: "/reward/analytics1", path: 'RewardManagement' },
    { url: "/reward/analytics", path: 'RewardManagement/Analytics' },
    { url: "/reward/history", path: 'RewardManagement/History' },
    { url: "/rewardpoints", path: 'rewardpoints' },
    { url: "/rewardpoints/add", path: 'rewardpoints/AddEdit' },
    { url: "/rewardpoints/edit/:id", path: 'rewardpoints/AddEdit' },
    { url: "/rewardpoints/detail/:id", path: 'rewardpoints/View' },

    { url: "/grooveEvents", path: 'GrooveEvents' },
    { url: "/grooveEvents/add", path: 'GrooveEvents/AddEdit' },
    { url: "/grooveEvents/edit/:id", path: 'GrooveEvents/AddEdit' },
    { url: "/grooveEvents/detail/:id", path: 'GrooveEvents/View' },

    { url: "/guide/downloads", path: 'GuidesAndDownloads' },
    { url: "/guide/downloads/add", path: 'GuidesAndDownloads/AddEdit' },
    { url: "/guide/downloads/edit/:id", path: 'GuidesAndDownloads/AddEdit' },
    { url: "/guide/downloads/detail/:id", path: 'GuidesAndDownloads/View' },

    { url: "/grooveCatering", path: "GrooveCatering" },
    { url: "/caterings/detail/:id", path: 'GrooveCatering/view' },

    { url: "/grooveEventRequest", path: "GrooveEventRequest" },
    { url: "/grooveEventRequest/detail/:id", path: 'GrooveEventRequest/view' },

    { url: "/weeklyMealOrders", path: "WeeklyMealOrders" },
    { url: "/weeklyMealOrders/detail/:id", path: 'WeeklyMealOrders/View' },
    { url: "/weeklyMealOrders/edit/:id", path: 'WeeklyMealOrders/AddEdit' },

    // { url: "/GrooveLocation", path: "GrooveLocation" },
    { url: "/GrooveLocation/edit/:id", path: 'GrooveLocation/AddEdit' },
    // { url: "/GrooveLocation/detail/:id", path: 'GrooveLocation/View' },

    { url: "/GrooveMealPlans", path: "GrooveMealPlans" },
    { url: "/GrooveMealPlans/add", path: 'GrooveMealPlans/AddEdit' },
    { url: "/GrooveMealPlans/edit/:id", path: 'GrooveMealPlans/AddEdit' },
    { url: "/GrooveMealPlans/detail/:id", path: 'GrooveMealPlans/View' },

    { url: "/GrooveMealType", path: "GrooveMealType" },
    { url: "/GrooveMealType/add", path: 'GrooveMealType/AddEdit' },
    { url: "/GrooveMealType/edit/:id", path: 'GrooveMealType/AddEdit' },
    { url: "/GrooveMealType/detail/:id", path: 'GrooveMealType/View' },

    { url: "/GrooveExtraMeals", path: "GrooveExtraMeals" },
    { url: "/GrooveExtraMeals/add", path: 'GrooveExtraMeals/AddEdit' },
    { url: "/GrooveExtraMeals/edit/:id", path: 'GrooveExtraMeals/AddEdit' },
    { url: "/GrooveExtraMeals/detail/:id", path: 'GrooveExtraMeals/View' },

    { url: "/GrooveDrinks", path: "GrooveDrinks" },
    { url: "/GrooveDrinks/add", path: 'GrooveDrinks/AddEdit' },
    { url: "/GrooveDrinks/edit/:id", path: 'GrooveDrinks/AddEdit' },
    { url: "/GrooveDrinks/detail/:id", path: 'GrooveDrinks/View' },


    { url: "/MostPopularGrooves", path: "MostPopularGrooves" },
    { url: "/MostPopularGrooves/add", path: 'MostPopularGrooves/AddEdit' },
    { url: "/MostPopularGrooves/edit/:id", path: 'MostPopularGrooves/AddEdit' },
    { url: "/MostPopularGrooves/detail/:id", path: 'MostPopularGrooves/view' },

    { url: "/grooveBuildYourOwn", path: "GrooveBuildYourOwn" },
    { url: "/grooveBuildYourOwn/add", path: 'GrooveBuildYourOwn/AddEdit' },
    { url: "/grooveBuildYourOwn/edit/:id", path: 'GrooveBuildYourOwn/AddEdit' },
    { url: "/grooveBuildYourOwn/detail/:id", path: 'GrooveBuildYourOwn/View' },

    { url: "/inventory", path: 'Inventory' },
    { url: "/inventory/add", path: 'Inventory/AddEdit' },
    { url: "/inventory/edit/:id", path: 'Inventory/AddEdit' },
    { url: "/inventory/detail/:id", path: 'Inventory/View' },
    { url: "/inventory/logs", path: 'Inventory/InventoryLogs' },
    { url: "/inventoryRetail", path: 'InventoryRetail' },
    { url: "/inventoryRetail/add", path: 'InventoryRetail/AddEdit' },
    { url: "/inventoryRetail/cron", path: 'InventoryRetail/History' },
    { url: "/inventoryRetail/cron/detail/:id", path: 'InventoryRetail/HistoryView' },

    { url: "/inventoryRetail/edit/:id", path: 'InventoryRetail/AddEdit' },
    { url: "/inventoryRetail/detail/:id", path: 'InventoryRetail/View' },
    { url: "/history/detail/:id", path: 'InventoryReconcileHistory/View' },
    { url: "/inventoryReconcile", path: 'InventoryReconcile' },
    { url: "/inventoryReconcile/add", path: 'InventoryReconcile/AddEdit' },
    { url: "/inventoryReconcile/edit/:id", path: 'InventoryReconcile/AddEdit' },
    { url: "/inventoryReconcile/detail/:id", path: 'InventoryReconcile/View' },

    { url: "/inventory/product", path: 'InventoryProduct' },
    { url: "/inventory/product/add", path: 'InventoryProduct/AddEdit' },
    { url: "/inventory/product/edit/:id", path: 'InventoryProduct/AddEdit' },
    { url: "/inventory/product/detail/:id", path: 'InventoryProduct/View' },
    { url: "/inventory/history/:productId/:id?", path: 'InventoryProduct/History' },


    { url: "/inventory/barcode", path: 'InventoryBarcode' },
    { url: "/inventory/barcode/add", path: 'InventoryBarcode/AddEdit' },
    { url: "/inventory/barcode/edit/:id", path: 'InventoryBarcode/AddEdit' },
    { url: "/inventory/barcode/detail/:id", path: 'InventoryBarcode/View' },
    { url: "/inventory/qrcode/add", path: 'InventoryQrCode/AddEdit' },

    { url: "/inventory/vendor", path: 'InventoryVendor' },
    { url: "/inventory/vendor/add", path: 'InventoryVendor/AddEdit' },
    { url: "/inventory/vendor/edit/:id", path: 'InventoryVendor/AddEdit' },
    { url: "/inventory/vendor/detail/:id", path: 'InventoryVendor/View' },
    { url: "/inventory/vendor/history", path: 'InventoryVendor/History' },
    { url: "/inventory/vendor/message", path: 'InventoryVendor/Message' },

    { url: "/inventory/vendor/request", path: 'InventoryVendor/request' },
    { url: "/inventory/vendor/request/detail/:id", path: 'InventoryVendor/request/View' },



    { url: "/uom", path: 'InventoryUOM' },
    { url: "/uom/add", path: 'InventoryUOM/AddEdit' },
    { url: "/uom/edit/:id", path: 'InventoryUOM/AddEdit' },

    { url: "/brands", path: 'InventoryBrand' },
    { url: "/brands/add", path: 'InventoryBrand/AddEdit' },
    { url: "/brands/edit/:id", path: 'InventoryBrand/AddEdit' },

    { url: "/reasons", path: 'ReconcileReason' },
    { url: "/reasons/add", path: 'ReconcileReason/AddEdit' },
    { url: "/reasons/edit/:id", path: 'ReconcileReason/AddEdit' },

    { url: "/subcategory", path: 'InventorySubcategory' },
    { url: "/subcategory/add", path: 'InventorySubcategory/AddEdit' },
    { url: "/subcategory/edit/:id", path: 'InventorySubcategory/AddEdit' },

    { url: "/group", path: 'InventoryGroup' },
    { url: "/group/add", path: 'InventoryGroup/AddEdit' },
    { url: "/group/edit/:id", path: 'InventoryGroup/AddEdit' },
    { url: "/group/history/:groupId", path: 'InventoryGroup/History' },

    { url: "/infusedby", path: 'InventoryInfusedby' },
    { url: "/infusedby/add", path: 'InventoryInfusedby/AddEdit' },
    { url: "/infusedby/edit/:id", path: 'InventoryInfusedby/AddEdit' },

    { url: "/Passes", path: 'Passes' },
    { url: "/passes/add", path: 'Passes/AddEdit' },
    { url: "/passes/edit/:id", path: 'Passes/AddEdit' },

    { url: "/thresholds", path: 'InventoryThreshold' },
    { url: "/thresholds/add", path: 'InventoryThreshold/AddEdit' },
    { url: "/thresholds/edit/:id", path: 'InventoryThreshold/AddEdit' },

    { url: "/RetailPrice", path: 'InventoryRetailPrice' },
    { url: "/RetailPrice/add", path: 'InventoryRetailPrice/AddEdit' },
    { url: "/RetailPrice/edit/:id", path: 'InventoryRetailPrice/AddEdit' },

    { url: "/boxInventory", path: 'BoxInventory' },
    { url: "/boxInventory/add", path: 'BoxInventory/AddEdit' },
    { url: "/boxInventory/edit/:id", path: 'BoxInventory/AddEdit' },
    { url: "/boxInventory/detail/:id", path: 'BoxInventory/View' },

    { url: "/boxHub", path: 'BoxHub' },
    { url: "/boxHub/add", path: 'BoxHub/AddEdit' },
    { url: "/boxHub/edit/:id", path: 'BoxHub/AddEdit' },
    { url: "/boxHub/detail/:id", path: 'BoxHub/View' },

    { url: "/inventory/bulk", path: 'InventoryBulk' },
    { url: "/inventoryMessage", path: 'InventoryMessage' },
    { url: "/inventoryReconcile/history", path: 'InventoryReconcileHistory' },
    { url: "/inventoryReconcile/history/detail/:id", path: 'InventoryReconcile/View' },

    { url: "/conversion", path: 'ConversionManagement' },
    { url: "/conversion/add", path: 'ConversionManagement/AddEdit' },
    { url: "/conversion/detail/:id", path: 'ConversionManagement/View' },
    { url: "/conversion/edit/:id", path: 'ConversionManagement/AddEdit' },
    { url: "/conversion/history", path: 'ConversionManagement/History' },
    { url: "/conversion/logs", path: 'ConversionManagement/ConversionLogs' },
    { url: "/po", path: 'PurchaseOrder' },
    { url: "/po/add", path: 'PurchaseOrder/AddEdit' },
    { url: "/po/detail/:id", path: 'PurchaseOrder/View' },
    { url: "/po/edit/:id", path: 'PurchaseOrder/AddEdit' },
    { url: "/po/history", path: 'PurchaseOrder/History' },

    { url: "/internal-transfer", path: 'InternalTransfer' },
    { url: "/internal-transfer/add", path: 'InternalTransfer/AddEdit' },
    { url: "/internal-transfer/detail/:id", path: 'InternalTransfer/View' },
    { url: "/internal-transfer/edit/:id", path: 'InternalTransfer/AddEdit' },
    { url: "/internal-transfer/history", path: 'InternalTransfer/History' },

    { url: "/activity-logs/:type/:id", path: 'ActivityLogs' },
    { url: "/activity-logs/:type/:id/product/:productId", path: 'ActivityLogs' },
    { url: "/product-logs/:productId", path: 'ProductLogs' },

    { url: "/marketing", path: 'Marketing' },
    { url: "/marketing/campaign-performance", path: 'Marketing/CampaignPerformance' },
    { url: "/marketing/referral", path: 'Marketing/ReferralDemographics' },
    { url: "/marketing/history", path: 'Marketing/History' },
    { url: "/marketing/report-list", path: 'Marketing/ReportList' },
    { url: "/marketing/autopay-report", path: 'Marketing/AutoPayReportList' },
    { url: "/loyal-member", path: 'LoyalMember' },
    { url: "/importproducts", path: 'Importproducts' },
    { url: "/importproducts/edit/:importId", path: 'Products/AddEdit' },
    { url: "/importproducts/detail/:id", path: 'Importproducts/View' },
    { url: "/referrals", path: 'Referrals' },
    { url: "/groove-guide/reports", path: 'GrooveGuide/Reports' },
    { url: "/groove-guide", path: 'GrooveGuide' },
    { url: "/referrals/detail/:id", path: 'Referrals/View' },
    { url: "/reward-report", path: 'RewardReports' },
    { url: "/discount-report", path: 'DiscountReports' },
    { url: "/discount", path: 'Discounts' },
    { url: "/discount/detail/:id", path: 'Discounts/View' },
    { url: "/reward-request", path: 'RewardRequest' },
    { url: "/reward-request/detail/:id", path: 'RewardRequest/View' },
    { url: "/box", path: 'Box' },
    // { url: "/box/analytics", path: 'Box/Analytics' },
    { url: "/box/analytics", path: 'Box/Insights' },
    { url: "/box/analytics22", path: 'Box/InsightsNew' },
    { url: "/box/analytics2", path: 'Box/InsightNew2' },



    { url: "/box2.0/report", path: 'Box/Report' },
    { url: "/box2.0/report-list", path: 'Box/ReportList' },
    { url: "/box2.0", path: 'Box2' },
    { url: "/box-tracking/:id", path: 'Box/Tracking', noAuth: true },
    { url: "/month-box", path: 'MonthBox' },
    { url: "/month-box/add", path: 'MonthBox/AddEdit' },
    { url: "/month-box/detail/:id", path: 'MonthBox/View' },
    { url: "/month-box/edit/:id", path: 'MonthBox/AddEdit' },
    { url: "/merch-category", path: 'MerchCategory' },
    { url: "/merch-category/add", path: 'MerchCategory/AddEdit' },
    { url: "/merch-category/detail/:id", path: 'MerchCategory/View' },
    { url: "/merch-category/edit/:id", path: 'MerchCategory/AddEdit' },
    { url: "/this-week-playlist", path: 'ThisWeekPlaylist' },
    { url: "/wallet-points", path: 'WalletPoints' },
    { url: "/wallet-points/detail/:email", path: 'DiscountReward' },

    { url: "/reward-type", path: 'RewardTypes' },
    { url: "/reward-type/add", path: 'RewardTypes/AddEdit' },
    { url: "/reward-type/detail/:id", path: 'RewardTypes/View' },
    { url: "/reward-type/edit/:id", path: 'RewardTypes/AddEdit' },
    { url: "/discount-reward/:email", path: 'DiscountReward' },
    { url: "/marketing/seo", path: 'SeoAnalytics/Dashbard/index.js' },
    { url: "/marketing/seo/reporting", path: 'SeoAnalytics/Reporting' },
    { url: "/marketing/seo/reporting/add", path: 'SeoAnalytics/Reporting/AddEdit' },
    { url: "/marketing/seo/reporting/edit/:id", path: 'SeoAnalytics/Reporting/AddEdit' },
    { url: "/marketing/seo/reporting/detail/:id", path: 'SeoAnalytics/Reporting/View' },
    { url: "/marketing/seo/audit", path: 'SeoAnalytics/SEOLogs' },
    { url: "/marketing/seo/audit/add", path: 'SeoAnalytics/SEOLogs/AddEdit' },
    { url: "/marketing/seo/audit/edit/:id", path: 'SeoAnalytics/SEOLogs/AddEdit' },
    { url: "/marketing/seo/audit/detail/:id", path: 'SeoAnalytics/SEOLogs/View' },

    /*EVA Voice Agent routes start*/
    { url: "/eva/agent", path: 'EVAAgents' },
    { url: "/eva/agent/add", path: 'EVAAgents/AddEdit' },
    { url: "/eva/agent/edit/:id", path: 'EVAAgents/AddEdit' },
    { url: "/eva/agent/detail/:id", path: 'EVAAgents/View' },
    { url: "/eva/fallback-handling", path: 'EVAFallbackHandling' },
    { url: "/eva/fallback-handling/detail/:id", path: 'EVAFallbackHandling/View' },
    { url: "/eva/phone-numbers", path: 'EVAPhoneNumbers' },
    { url: "/eva/call-ratings", path: 'EVACallRatings' },
    { url: "/eva/call-rating/detail/:id", path: 'EVACallRatings/View' },
    { url: "/seo/dashboard", path: 'SEODashboard/SeoDashboard' },

    /*EVA Voice Agent routes end*/
    { url: "/eva/call-logs", path: 'EVACallLogs' },
    { url: "/eva/call-logs/conversation-details/:id", path: 'EVACallLogs/View' },
    { url: "/eva/quality-reports", path: 'EVAQualityReports' },
    { url: "/eva/call-analytics", path: 'EVACallAnalytics' },
    { url: "/eva/messaging-inbox", path: 'EVAMessagingInbox' },
    { url: "/eva/messaging-inbox/detail/:id", path: 'EVAMessagingInbox/View' },

    // { url: "/eva/transfer-call-logs", path: 'EVATransferCallLogs' },
    { url: "/thresholds/dashboard", path: 'InventoryThreshold/Dashboard' },
    { url: "/thresholds/families", path: 'InventoryThreshold/Families' },
    { url: "/thresholds/families/add", path: 'InventoryThreshold/Families/AddEdit' },
    { url: "/thresholds/families/edit/:id", path: 'InventoryThreshold/Families/AddEdit' },
    { url: "/thresholds/families/detail/:id", path: 'InventoryThreshold/Families/view' },
    { url: "/family/detail", path: 'InventoryThreshold/Families/view' },

    // Global Activity Timeline
    { url: "inventory/activity/timeline", path: "GlobalActivityTimeline" }
  ];

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
          <Router>
            <FulfillmentRouteState />
            <Suspense fallback={<Loading />}>
              <Routes>
                {routes.map((itm: any) => {
                  const Component = lazy(() => import(
                    /* webpackExclude: /\.(?:test|spec)\.[jt]sx?$/ */
                    `./Pages/${itm.path}`
                  ));

                  let auth = (itm?.auth || !itm?.noAuth)


                  const Element = <PageRoute url={itm.url} auth={auth ? true : false} Layout={auth ? Layout : ''}>
                    <Component />
                  </PageRoute>
                  return <Route path={itm.url} element={itm.element || Element} />;
                })}
                <Route path="/go/live" element={<LivePageSettings />} />

              </Routes>
            </Suspense>
          </Router>
        </PersistGate>
      </Provider>
      <Loading id="loader" className="d-none" />
      <ToastContainer position="top-right" />
    </>
  );
})

export default App;
